import React from "react";

import { Helmet } from "react-helmet";

import ForgotPasswordForm from "./Form";

const ForgotPassword = () => {
  return (
    <>
      <Helmet title="OVOU | Forgot Password" />
      <div className="flex flex-col items-center justify-center bg-white h-full">
        <div className="w-full">
          <div className="mt-16">
            <h1 className="text-black font-extrabold text-3xl">
              Forgot your password?
            </h1>
          </div>
          <div className="flex flex-col mt-8">
            <ForgotPasswordForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
